import { authentication, app } from "@microsoft/teams-js";
import { initializeTeamsApp } from '../helpers/teamsApp';

async function getAccessToken(): Promise<string> {
    await initializeTeamsApp();

    const authTokenRequest = {
        resources: []
    };
    return authentication.getAuthToken(authTokenRequest).then((token: string) => {
        return token;
    }).catch((error: string) => {
        return "Error getting token: " + error
    })
}

async function fetchWrapper (input: RequestInfo, init?: RequestInit): Promise<Response> {
    const token = await getAccessToken();
    if (!!!init) {
        init = { }
    }

    init.headers = { ...init.headers, "Authorization": "Bearer " + token };
    return await fetch(input, init);;
}

export default fetchWrapper;